import {PALETTE_IDS} from '#core/application/modules/ids.js';
import {SPORT_BACKGROUND_IMAGE_MAP} from '#core/application/modules/sports-content/sport-page/sport-page.factory.js';
import {getSportBackgroundImages} from '#core/application/modules/sports-content/sport-page/utils.js';

const CUSTOM_SPORT_BACKGROUND_IMAGE_MAP = {
    ...SPORT_BACKGROUND_IMAGE_MAP,
    // list of sports in the mapping but customized icons not ready yet, will be replaced when ready
    boxing: 'generic',
    cycling: 'generic',
    futsal: 'generic',
    greyhound_racing: 'generic',
    horse_racing: 'generic',
    martial_arts: 'generic',
    //
    badminton: 'badminton',
    esports: 'esports',
    rugby_league: 'rugby_league',
    rugby_union: 'rugby_union',
};

export function getSportsContentConfigs() {
    return {
        custom: {
            [PALETTE_IDS.SPORTS_CONTENT]: {
                SportPage: {
                    sportBackgroundImages: getSportBackgroundImages({
                        sportBackgroundImageMap: CUSTOM_SPORT_BACKGROUND_IMAGE_MAP,
                    }),
                    _mobile_sportBackgroundImages: getSportBackgroundImages({
                        sportBackgroundImageMap: CUSTOM_SPORT_BACKGROUND_IMAGE_MAP,
                        folderName: 'mobile',
                    }),
                },
            },
        },
        palette: {},
    };
}
